<script setup>
  import {ref, watch} from "vue";

  import {MedCheckbox} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "ComponentTableHeadCheckbox",
  });

  const props = defineProps({
    selectedRows: {
      type: Array,
      required: true,
    },
    availableRows: {
      type: Array,
      required: true,
    },
  });

  const emit = defineEmits(["update:selectedRows"]);

  const isChecked = ref(false);

  // reset selection when available rows change
  watch(
    () => props.availableRows,
    () => {
      emit("update:selectedRows", []);
    },
  );

  // update head checkbox if selectedRows change
  watch(
    () => props.selectedRows,
    (rows) => {
      const selectedCount = rows.length;
      const totalCount = props.availableRows.length;

      if (selectedCount === 0) {
        isChecked.value = false;
      } else if (totalCount > 0 && selectedCount === totalCount) {
        isChecked.value = true;
      } else {
        isChecked.value = "indeterminate";
      }
    },
  );

  // toggle selection and update selected rows accordingly
  function toggleSelection() {
    // isChecked is the previous value, so we need to invert it
    if (!isChecked.value || isChecked.value === "indeterminate") {
      emit("update:selectedRows", props.availableRows);
    } else {
      emit("update:selectedRows", []);
    }
  }
</script>

<template>
  <div class="flex size-6 shrink-0 items-center justify-center stroke-0">
    <MedCheckbox v-model="isChecked" variant="primary" :data-test="getTestId('checkbox')" @click="toggleSelection" />
  </div>
</template>
